import { getLocationParams } from 'lib/frontend/utils/browser';
import {
  BROWSER,
  BROWSERS,
  IS_DEPLOY_PREVIEW,
  IS_LOCALHOST
} from '../constants';

export const getHostname = () =>
  window.location.hostname.split('.').slice(-2)[0];

// TODO: Replace this with a useParams hook?
export const getRedirect = () =>
  getLocationParams().get('redirect') || '/?noredirect';

// TODO: Replace this with a useParams hook?
export const includeSearchParams = (url: string) =>
  `${url}${window.location.search}`;

const locationParamsToTuples = (searchParams: URLSearchParams) => {
  const result = [];
  for (const entry of searchParams) {
    const [key, value] = entry;
    result.push([key, value]);
  }
  return result;
};

export const appendToCurrentParams = (key: string, value: string) => {
  const params = new URLSearchParams(
    Object.fromEntries([
      ...locationParamsToTuples(getLocationParams()),
      [key, value]
    ])
  );

  return params;
};

/**
 * addToCurrentURLParameters takes the key, value pairs in newURLParams and
 * returns a URLSearchParams object with those parameters as well as existing
 * URL parameters.
 * @param newURLParams object containing the key, value pairs to add to the URLSearchParams object
 * @returns a new URLSearchParams object with both the old and new params
 */
export const addToCurrentURLParameters = (
  newURLParams: Record<string, string>
) => {
  const params = new URLSearchParams(
    Object.fromEntries([
      ...locationParamsToTuples(getLocationParams()),
      ...Object.entries(newURLParams)
    ])
  );
  return params;
};

/**
 * Opposite of 'addToCurrentURLParameters'
 */
export const removeFromCurrentUrlParams = (key: string) => {
  const params = new URLSearchParams(
    Object.fromEntries([...locationParamsToTuples(getLocationParams())])
  );

  if (params.has(key)) {
    params.delete(key);
  }
  return params;
};

export const updateHistoryNoRerender = (path: string) => {
  window.history.replaceState(null, document.title, path);
  let event;
  if (BROWSER === BROWSERS.ie) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent('replacestate', true, true, {
      detail: 'replacestate'
    });
  } else {
    event = new CustomEvent('replacestate', { detail: 'replacestate' });
  }
  dispatchEvent(event);
};

export const getSubdomain = () => {
  if (IS_LOCALHOST || IS_DEPLOY_PREVIEW) {
    return process.env.REACT_APP_SUBDOMAIN || '';
  }
  return window.location.host.split('.')[0];
};

/** Get the current relevant subdomain */
export const getContextKey = () => {
  if (IS_LOCALHOST || IS_DEPLOY_PREVIEW) {
    return process.env.REACT_APP_SUBDOMAIN || null;
  }

  const hostname = getHostname();
  if (['publicnoticecolorado'].indexOf(hostname) !== -1) return hostname;

  const subdomain = getSubdomain();

  // Don't count www.column.us or demo.enotice.io as valid subdomains
  if (subdomain === 'www') return null;
  if (subdomain === 'demo') return null;
  if (subdomain === 'column-staging') return null;

  return subdomain;
};
